// src/components/Profile/ImagePreviewModal.jsx
import React from 'react';

export default function ImagePreviewModal({ imageUrl, isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <i className="ph ph-x"></i>
        </button>
        <img src={imageUrl} alt="Material" />
      </div>
    </div>
  );
}